import { useUnmount } from "react-use";

export default useUnmount;